ceregoCommon.factory('V4RecommendedSetsResource', ['$resource', ($resource) ->
  $resource "", {},
    query:
      method: 'GET'
      isArray: false
      url: APIRoutes.v4_recommended_sets_path()
])
